import Cookies from 'js-cookie';

import cryptoService from '../cryptoService';

class CookieClient {
    constructor() {
        this.cookie = Cookies;
    }

    getObjItem = (key) => {
        const result = this.getItem(key);

        if (result !== undefined) {
            return JSON.parse(result);
        } else {
            return null;
        }
    };

    setObjItem = (key, value, option) => this.setItem(key, JSON.stringify(value), option);

    getItem = (key) => this.cookie.get(key);

    setItem = (key, value, option) => this.cookie.set(key, value, option);

    removeItem = (key, path) => this.cookie.remove(key, path);

    getEncodedItem = (key) => {
        try {
            const item = this.getItem(key);
            const encodedItem = cryptoService.encodeAtob(item);

            return encodedItem;
        } catch (e) {
            return null;
        }
    };
}

const cookieClient = new CookieClient();

export default cookieClient;
